import { useCallback, useEffect, useRef } from "react"
import { clamp, throttle } from "lodash-es"

let spare: number | undefined

function generateGaussianRandom(mean = 0, stdDev = 1) {
    if (spare !== undefined) {
        const result = spare
        spare = undefined
        return result * stdDev + mean
    }

    const u1 = Math.random()
    const u2 = Math.random()

    const mag = stdDev * Math.sqrt(-2.0 * Math.log(u1))
    const z0 = mag * Math.cos(2.0 * Math.PI * u2) + mean
    const z1 = mag * Math.sin(2.0 * Math.PI * u2) + mean

    spare = z1
    return z0
}

export const useMaskCanvas = () => {
    const canvasRef = useRef<HTMLCanvasElement>(null)
    const drawMask = useCallback(() => {
        const ele = canvasRef.current
        if (!ele) return

        const ctx = ele.getContext("2d")
        if (!ctx) return

        ele.width = ele.clientWidth
        ele.height = ele.clientHeight

        ctx.fillStyle = "rgba(0, 0, 0, 1)"
        ctx.fillRect(0, 0, ele.width, ele.height)

        const imageData = ctx.createImageData(ele.width, ele.height)
        const data = imageData.data

        const stdDev = 1
        const baseColor = [249, 241, 241]
        const intensity = 0.0726

        // 为每个像素生成高斯噪声
        for (let i = 0; i < data.length; i += 4) {
            // 生成高斯噪声值
            const gaussianNoise = generateGaussianRandom(0, stdDev)
            const noiseValue = gaussianNoise * intensity * 255

            // 设置RGB为相同值（单色）
            data[i] = clamp(Math.round(baseColor[0] + noiseValue), 0, 255) // Red
            data[i + 1] = clamp(Math.round(baseColor[1] + noiseValue), 0, 255) // Green
            data[i + 2] = clamp(Math.round(baseColor[2] + noiseValue), 0, 255) // Blue
            data[i + 3] = 255 // Alpha (完全不透明)
        }

        // 将图像数据绘制到canvas
        ctx.putImageData(imageData, 0, 0)
    }, [])
    useEffect(() => {
        drawMask()
        const cb = throttle(drawMask, 1000)
        const ele = canvasRef.current
        if (!ele) return
        ele.addEventListener("resize", cb)
        return () => {
            ele.removeEventListener("resize", cb)
        }
    }, [drawMask])
    return canvasRef
}
